import { render, staticRenderFns } from "./PageMenuItem.vue?vue&type=template&id=57613e02"
import script from "./PageMenuItem.vue?vue&type=script&lang=js"
export * from "./PageMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports